<template>
    <div class="proportionSetting">
        <el-dialog title="比例设置" :visible.sync="dialogVisible" width="600">
            <div class="settingBox">
                <div class="joinSwitch">
                   <span>参与推广</span><el-switch v-model="proportion.isdistribute"></el-switch>
                </div>
                <div class="choiceProportion">
                    <div class="title">比例设置</div>
                    <div class="choiceBox">
                        <el-radio v-model="proportion.brokeragetype" :label="1">默认比例</el-radio>
                        <el-radio v-model="proportion.brokeragetype" :label="2">自定义比例</el-radio>
                        <p class="tips">注意：如需修改默认佣金比例，请前往【推广员】-【设置】-【推广规则】</p>
                    </div>
                </div>
                <el-table :data="proportion.defaultgoodbrokeragelist" style="width: 100%" v-if="proportion.brokeragetype === 1">
                    <el-table-column prop="leveltypeText" label="推广员级别"></el-table-column>
                    <el-table-column label="直接推广佣金比例" class-name="center">
                        <template slot-scope="scope">
                            <div class="direct">
                                <span v-if="proportion.brokeragetype === 1 && proportion.isdistribute">{{scope.row.diectbrokeragerate}}%</span>
                                <span v-else-if="proportion.brokeragetype === 1 && !proportion.isdistribute">0.00%</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="secondbrokeragerate" label="间接推广佣金比例" class-name="center">
                        <template slot-scope="scope">
                            <div class="indirect">
                                <span v-if="proportion.brokeragetype === 1 && proportion.isdistribute">{{scope.row.secondbrokeragerate}}%</span>
                                <span v-else-if="proportion.brokeragetype === 1 && !proportion.isdistribute">0.00%</span>
                                <div v-else>
                                    <el-input v-model="scope.row.secondbrokeragerate"></el-input>%
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table :data="proportion.goodbrokeragelist" style="width: 100%" v-if="proportion.brokeragetype === 2">
                    <el-table-column prop="leveltypeText" label="推广员级别"></el-table-column>
                    <el-table-column label="直接推广佣金比例" class-name="center">
                        <template slot-scope="scope">
                            <div class="direct">
                                <div>
                                    <el-input v-model="scope.row.diectbrokeragerate"></el-input>%
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="secondbrokeragerate" label="间接推广佣金比例" class-name="center">
                        <template slot-scope="scope">
                            <div class="indirect">
                                <div>
                                    <el-input v-model="scope.row.secondbrokeragerate"></el-input>%
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click.native="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getCommodityProportion, commodityProportionSet} from '@/api/distribution'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'proportionSetting',
    data() {
        return {
            dialogVisible:false,
            joinGeneralize: true,

            params: {
                kmcinnerid: '',
                kmctype: ''
            },
            proportion: {
                isdistribute: 0,
                innerid: '',
                brokeragetype: 1,
                goodbrokeragelist: []
            }
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.dialogVisible = false
        },
        confirm() {
            // 调接口
            if (this.proportion.brokeragetype === 2) {
                if ((parseFloat(this.proportion.goodbrokeragelist[1].diectbrokeragerate) > 0 && parseFloat(this.proportion.goodbrokeragelist[0].diectbrokeragerate) > 0) && (parseFloat(this.proportion.goodbrokeragelist[1].secondbrokeragerate) > 0 && parseFloat(this.proportion.goodbrokeragelist[0].secondbrokeragerate) > 0)) {
                    let lowDirectProportion = parseFloat(this.proportion.goodbrokeragelist[0].diectbrokeragerate) // 普通推广员直接佣金
                    let lowUndirectProportion = parseFloat(this.proportion.goodbrokeragelist[0].secondbrokeragerate) // 普通推广员间接佣金
                    let highDirectProportion = parseFloat(this.proportion.goodbrokeragelist[1].diectbrokeragerate) // 高级推广员直接佣金
                    let highUndirectProportion = parseFloat(this.proportion.goodbrokeragelist[1].secondbrokeragerate) // 高级推广员间接佣金
                    if (this.proportion.goodbrokeragelist.length === 3) {
                        if (parseFloat(this.proportion.goodbrokeragelist[2].diectbrokeragerate) && parseFloat(this.proportion.goodbrokeragelist[2].diectbrokeragerate) > 0) {
                            let superDirectProportion = parseFloat(this.proportion.goodbrokeragelist[2].diectbrokeragerate) // 超级推广员直接佣金
                            let superUndirectProportion = parseFloat(this.proportion.goodbrokeragelist[2].secondbrokeragerate) // 超级推广员间接佣金
                            if ((highDirectProportion > lowDirectProportion && superDirectProportion > highDirectProportion) && (highUndirectProportion > lowUndirectProportion && superUndirectProportion > highUndirectProportion)) {
                                this.saveProportion()
                                return
                            } else {
                                this.$message.error('高级的推广员佣金需比低级的大')
                                return
                            }
                        } else {
                            this.$message.error('推广员的佣金必须大于0')
                            return
                        }
                    } else if (highDirectProportion > lowDirectProportion &&  highUndirectProportion > lowUndirectProportion) {
                        this.saveProportion()
                    } else {
                        this.$message.error('高级的推广员佣金需比低级的大')
                        return
                    }
                } else {
                    this.$message.error('推广员的佣金必须大于0')
                }
            } else {
                this.saveProportion()
            }
        },
        saveProportion() {
            this.setLoading(true)
            if (this.proportion.isdistribute) {
                this.proportion.isdistribute = 1
            } else {
                this.proportion.isdistribute = 0
            }
            let obj = JSON.parse(JSON.stringify(this.proportion))
            obj.goodbrokeragelist = JSON.stringify(obj.goodbrokeragelist)
            obj.defaultgoodbrokeragelist = JSON.stringify(obj.defaultgoodbrokeragelist)
            commodityProportionSet({
                data: Object.assign({}, obj),
                success: data => {
                    this.$emit('getList')
                    this.dialogVisible = false
                    this.setLoading(false)
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        getProportion() {
            this.setLoading(true)
            getCommodityProportion({
                data: Object.assign({}, this.params),
                success: data => {
                    this.setLoading(false)
                    this.proportion = data.data
                    if (this.proportion.isdistribute) {
                        this.proportion.isdistribute = true
                    } else {
                        this.proportion.isdistribute = false
                    }
                    // this.proportion.goodbrokeragelist.forEach(obj => {
                    //     obj.directNum = '0.00'
                    //     obj.indirectNum = '0.00'
                    // })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        openDialog(v) {
            this.dialogVisible = true
            this.params.kmcinnerid = v.kmcinnerid
            this.params.kmctype = Number(v.kmctype)
            this.getProportion()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch:{}
}
</script>
<style lang="scss">
    .proportionSetting{
        .settingBox{
            .joinSwitch{
                .el-switch{
                    margin-left: 10px;
                }
            }
            .choiceProportion{
                margin-top: 32px;
                display: flex;
                .choiceBox{
                    margin-left: 40px;
                    .el-radio{
                        margin-right: 40px;
                    }
                    .el-radio__input.is-checked+.el-radio__label{
                        color: #303133;
                    }
                    .tips{
                        color: #909399;
                        font-size: 12px;
                        line-height: 16px;
                        margin-top: 10px;
                    }
                }
            }
            .el-table{
                .center{
                    .cell{
                        text-align: center;
                    }
                }
            }
            .direct,.indirect{
                .el-input{
                    width: 70px;
                    margin-right: 6px;
                }
            }
        }
    }
</style>